import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import LeftArrow from 'components/icons/LeftArrow'
import RightArrow from 'components/icons/RightArrow'
import Home from 'components/icons/Home'

import ToFromDisplay from 'components/ToFromDisplay'
import DayDisplay from 'components/DayDisplay'
import MediaModal from 'components/MediaModal'
import ShareButton from 'components/ShareButton'

import './styles.css'

class EventInfo extends Component {
  static propTypes = {
    event: PropTypes.shape({
      name: PropTypes.string.isRequired,
      arrive: PropTypes.string,
      depart: PropTypes.string,
      to: PropTypes.arrayOf(
        PropTypes.shape({
          departureDate: PropTypes.string,
          departureTime: PropTypes.string,
        })
      ),
    }).isRequired,
    nextEvent: PropTypes.shape({
      arrive: PropTypes.string,
      depart: PropTypes.string,
    }),
    previousEvent: PropTypes.shape({
      arrive: PropTypes.string,
      depart: PropTypes.string,
      to: PropTypes.arrayOf(
        PropTypes.shape({
          departureDate: PropTypes.string,
          departureTime: PropTypes.string,
        })
      ),
    }),
    hasPreviousEvent: PropTypes.bool.isRequired,
    hasNextEvent: PropTypes.bool.isRequired,
    goToPreviousEvent: PropTypes.func.isRequired,
    goToNextEvent: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    mediaDisplayed: PropTypes.bool,
    mediaId: PropTypes.string,
    mediaType: PropTypes.string,
    actions: PropTypes.shape({
      navViewMedia: PropTypes.func.isRequired,
      navCloseMedia: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    nextEvent: {},
    previousEvent: {},
    mediaDisplayed: false,
    mediaId: undefined,
    mediaType: undefined,
  }

  render() {
    const {
      event,
      nextEvent,
      previousEvent,
      hasPreviousEvent,
      hasNextEvent,
      goToPreviousEvent,
      goToNextEvent,
      actions,
      mediaDisplayed,
      mediaId,
    } = this.props

    let duration = 0
    const arrivalDate = moment(event.arrive).format('ddd Do MMM YYYY')
    const departureDate = hasNextEvent
      ? moment(nextEvent.arrive).format('ddd Do MMM YYYY')
      : ''
    if (hasPreviousEvent && hasNextEvent) {
      duration = moment(nextEvent.arrive).diff(moment(event.arrive), 'days') + 1
    }
    let inBoundTravel = ''
    if (
      !event.start &&
      !event.end &&
      previousEvent.to &&
      previousEvent.to.length
    ) {
      inBoundTravel = previousEvent.to.map(to => (
        <ToFromDisplay key={to.departureDate + to.departureTime} {...to} />
      ))
    }
    let outBoundTravel = ''
    if (event.to && event.to.length) {
      outBoundTravel = event.to.map(to => (
        <ToFromDisplay key={to.departureDate + to.departureTime} {...to} />
      ))
    }
    const itineraryDisplay = []
    // create a day entry for each day of trip, and populate with itinerary content if exists
    if (duration > 0) {
      for (let day = 1; day < duration + 1; day += 1) {
        const dayData =
          event.itinerary && event.itinerary[day - 1]
            ? event.itinerary[day - 1]
            : {}
        // const date = moment(event.arrive).add(day - 1, 'days').format('YYYY-MM-DD (ddd)')
        const date = moment(event.arrive)
          .add(day - 1, 'days')
          .format('ddd Do MMM YYYY')
        const tbclass =
          !dayData.descr || dayData.descr === 'TBC' ? 'day-display-tbc' : ''
        const hasActivitiesClass =
          dayData && dayData.activities && dayData.activities.length
            ? 'has-activities'
            : ''
        const dayDisplay = (
          <div
            className={`day-display ${tbclass} ${hasActivitiesClass}`}
            key={day}
          >
            <div className="date-display" title={date}>
              Day {day} - {date}
            </div>
            <DayDisplay
              {...dayData}
              openMedia={actions.navViewMedia}
              dayNum={day}
            />
          </div>
        )
        itineraryDisplay.push(dayDisplay)
      }
    }

    const durationDisplay =
      duration > 0 ? <div className="duration-days">{duration} Days</div> : ''

    return (
      <div className="event-info-display">
        <ShareButton width={32} />
        <div className="next-prev-links">
          {hasPreviousEvent && (
            <a className="prev-link" onClick={goToPreviousEvent}>
              <LeftArrow fill="white" width={40} />
            </a>
          )}
          {!hasPreviousEvent && (
            <div className="home-icon">
              <Home fill="white" width={40} />
            </div>
          )}
          {durationDisplay}
          {hasNextEvent && (
            <a className="next-link" onClick={goToNextEvent}>
              <RightArrow customClassName="next-link" fill="white" width={40} />
            </a>
          )}
          {!hasNextEvent && (
            <div className="home-icon">
              <Home fill="white" width={40} />
            </div>
          )}
        </div>
        {inBoundTravel && (
          <div className="inbound-travel">
            <div className="travel-date">
              <b>Arrive</b> - {arrivalDate}
            </div>
            {inBoundTravel}
          </div>
        )}
        {itineraryDisplay && (
          <div className="itinerary-container">{itineraryDisplay}</div>
        )}
        {outBoundTravel && (
          <div className="outbound-travel">
            <div className="travel-date">
              <b>Depart</b> - {departureDate}
            </div>
            {outBoundTravel}
          </div>
        )}
        {mediaDisplayed && (
          <MediaModal
            isOpen={mediaDisplayed}
            onRequestClose={actions.navCloseMedia}
            mediaId={mediaId}
          />
        )}
      </div>
    )
  }
}

export default EventInfo



// WEBPACK FOOTER //
// ./src/components/EventInfo/component.js